import React from 'react';
import DropDown from '../../DropDown';

const BrandSelector = ({ template, updateTickerStatus, tickerOption, setState, state }) => {
	const { tickers } = state;
	const brands = template.ticker.options || []
	const selectedBrand = brands && tickers && tickers[0] && brands.find(b => b.name === tickers[0])

	const chooseBrand = (brand) => {
		setState({ tickers: [brand.name] }, () => updateTickerStatus(true));
	};

	return (
		<>
			<DropDown ellipseWidth={230} stringStyle={{ padding: '11px 0' }} clickable fixed fullWidth label={tickerOption.selectionName} value={selectedBrand && selectedBrand.name} labelClassName='mt-none' maxDropdownHeight={"max(180px, calc(98vh - 372px))"}>
				{brands.sort((a, b) => {
					if (!a.name) return -1;
					else if (!b.name) return 1;
					else return a.name.localeCompare(b.name);
				}).map((option, index) => (
					<li key={index} onClick={() => chooseBrand(option, index)}>
						{option.name}
					</li>
				))}
			</DropDown>
		</>
	)
}

export default BrandSelector;